// Attempt to re-select previously selected style when product changes. This should avoid the user
// thinking they have to re-upload a new image to get a mockup for the currently selected product.
// This is needed to avoid a teeinblue limitation due to which they do not preserve style selection
// when changing product type.

let currentStyle = null;

// Handles clicks on style images to store the currently selected style
document.addEventListener('click', (event) => {
    const element = event.target;
    if (element instanceof HTMLElement
        && element.tagName.toLowerCase() === 'label'
        && element.getAttribute('for')
        && element.getAttribute('for').match(/template-template/)
    ) {
        currentStyle = element.getAttribute('data-title');
    }
});

// Restores the previous current selected style as soon as the product is changed
document.addEventListener('click', (event) => {
    if (!currentStyle) {
        // This happens if style was never changed before clicking on a new product.
        // TODO: identify selected style at page load so that this can be removed.
        return;
    }

    const element = event.target;
    if (element instanceof HTMLInputElement
        && element.classList.contains('tee-checkbox-input')
        && element.id
        && element.id.match(/^teeinblue-available-prod-/)
    ) {
        setTimeout(
            () => document.querySelector('label[data-title="'+currentStyle+'"]').click(),
            100
        );
    }
});
